import React, { Component } from 'react'
import './Roles.css'
import ErrorAlert from '../Alerts/ErrorAlert'
import * as languageSettings from '../Language/languageSettings'
import t from '../Language/language'
import { Config } from '../../Config'
import Api from '../../Api'
import { CommonConstants } from '../../Constants'
import AuthenticationService from '../../components/Security/AuthenticationService'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getPermissionsList } from '../../actions/roles'
import moment from 'moment'
import CommonLoader from '../Alerts/CommonLoader'
import { checkAccess } from '../../actions/permissions'
import CommonFunctions from '../../components/Common/Functions'
// Add Role - Component.
class AddRoles extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      PermissionList: '',
      permissionsUID: [],
      selectedPermissions: [],
      Rolename: '',
      Description: '',
      selectAll: false,
      errors: '',
      errorMessage: 'RoleName Cannot be empty',
      showCommonLoader: true,
      isSuccess: false
    }
    this.api = new Api()
    this.commonFunctions = new CommonFunctions()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.defaultPermission = this.defaultPermission.bind(this)
    this.getPermissionList = this.getPermissionList.bind(this)
    this.basicPermissionList = this.basicPermissionList.bind(this)
    this.adminPermissionList = this.adminPermissionList.bind(this)
    this.toggleChange = this.toggleChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.createRole = this.createRole.bind(this)
    this.selectAllPermissions = this.selectAllPermissions.bind(this)
    this.deselectAllPermissions = this.deselectAllPermissions.bind(this)
    this.cancleAll = this.cancleAll.bind(this)
  }

  // Setting the permission list to the state variable.
  componentWillReceiveProps (nextProps) {
    if (this.props.roles.permissionList) {
      this.setState({ PermissionList: this.props.roles.permissionList })
      this.defaultPermission()
    }
  }

  // Getting the permission list by service call.
  componentWillMount () {
    this.props.getPermissionsList(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  // default Selected Permissions
  defaultPermission () {
    let defaultPermission = {}
    defaultPermission = {
      value: CommonConstants.value,
      isChecked: CommonConstants.isChecked,
      index: CommonConstants.DefaultPermissionIndex
    }
    this.setState({
      selectedPermissions: [defaultPermission]
    })
  }
  // display  Permission LIST
  getPermissionList () {
    const { language } = this.state
    return (
      <div className='rolesTable'>
        <div className='roleAssignementHeaderBasic' translate='' key='Basic'>{t[language].Basic}</div>
        <div>
          {this.basicPermissionList()}
        </div>
        <div className='roleAssignementHeaderAdmin' translate='' key='Admin'>{t[language].Admin}</div>
        <div>
          {this.adminPermissionList()}
        </div>
      </div>
    )
  }

  // get basic Permission
  basicPermissionList () {
    const { language } = this.state
    let basicPermissions
    if (this.state.PermissionList) {
      basicPermissions = this.state.PermissionList.map((item, index) => {
        if (item.Permission_Type === 'Basic') {
          return (
            <div>
              <label>
                <input
                  type='checkbox'
                  className='permission'
                  value={item.Permission_UID}
                  checked={item.isChecked}
                  onChange={e => this.toggleChange(e, index)}
                />
                <span className='labelFont'>{t[language][item.Permission_Name]}</span>
              </label>
            </div>
          )
        } else { return null }
      })
    }
    return basicPermissions
  }
  // get Admin Permisssions
  adminPermissionList () {
    let adminPermissions
    const { language } = this.state
    if (this.state.PermissionList) {
      adminPermissions = this.state.PermissionList.map((item, index) => {
        if (item.Permission_Type === 'Admin') {
          return (
            <div>
              <label>
                <input
                  type='checkbox'
                  className='permission'
                  checked={item.isChecked}
                  value={item.Permission_UID}
                  onChange={e => this.toggleChange(e, index)}
                />
                <span className='labelFont'>{t[language][item.Permission_Name]}</span>
              </label>
            </div>
          )
        } else { return null }
      })
    }
    return adminPermissions
  }

  // handleChange
  handleChange (field, e) {
    let value
    switch (field) {
      case 'name':
        value = e.target.value
        this.setState({ Rolename: value })
        break
      case 'desc':
        value = e.target.value
        this.setState({ Description: value })
        break
      default:
        break
    }
  }
  // Select All
  selectAllPermissions () {
    if (this.state.PermissionList) {
      let permissionsID = []
      this.state.PermissionList.forEach((permission, index) => {
        let item = {}
        item.value = permission.Permission_UID
        item.isChecked = true
        item.index = index
        permissionsID.push(item)
      })
      this.setState({ selectedPermissions: permissionsID })
      let permissions = this.state.PermissionList.map((item, index) => {
        if (!item.isChecked) {
          item.isChecked = true
        }
        return item
      })
      this.setState({ PermissionList: permissions })
      this.setState({ selectAll: true })
    }
  }
  // Deselect All
  deselectAllPermissions () {
    if (this.state.PermissionList) {
      let permissionsID = []
      this.setState({ selectedPermissions: permissionsID })
      this.setState({ selectAll: false })
      this.setState({
        PermissionList: this.state.PermissionList.map((item, index) => {
          let permissionsList = {
            ...item,
            isChecked: false
          }
          return permissionsList
        })
      })
    }
  }

  // checkbox on change event
  toggleChange (e, indexToChange) {
    let permissions = this.state.selectedPermissions
    const value = e.target.value
    const isChecked = e.target.checked
    let items = {}
    if (permissions.length > 0) {
      permissions.forEach((item, index) => {
        if (item[index] === indexToChange) {
          permissions[index].isChecked = isChecked
        } else {
          items.value = value
          items.isChecked = isChecked
          items.index = indexToChange
        }
      })
      permissions.push(items)
      this.setState({ selectedPermissions: permissions })
    } else {
      items.value = value
      items.isChecked = isChecked
      items.index = indexToChange
      permissions.push(items)
      this.setState({ selectedPermissions: permissions })
    }
    this.setState({
      PermissionList: this.state.PermissionList.map((item, index) => {
        if (index === indexToChange) {
          return {
            ...item,
            isChecked: e.target.checked
          }
        }
        return item
      })
    })
  }

  // create roles permission
  createRole (e) {
    this.setState({ errors: [] })
    const { language } = this.state
    e.preventDefault()
    // Post call
    let permissionsId = []
    let permissionUID = this.commonFunctions.removeDuplicate(this.state.selectedPermissions, false)
    permissionUID.forEach(item => {
      if (item.isChecked === true) {
        permissionsId.push(item.value)
      }
    })
    let roleName = (this.state.Rolename).trim()
    let result = this.commonFunctions.validateRoles(permissionsId, roleName)
    let isFormValid = result.isformValidation
    if (isFormValid) {
      this.setState({ showCommonLoader: true })
      let createRoles = {}
      createRoles.permissionUid = permissionsId
      createRoles.roleName = (this.state.Rolename).trim()
      createRoles.roleDesc = this.state.Description ? (this.state.Description).trim() : ''
      createRoles.createdDateTime = moment().format('YYYY-MM-DD HH:mm:ss')
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.createRole
      this.api.postData(url, createRoles, data => {
        if (data.status) {
          this.setState({ showCommonLoader: false, isSuccess: true })
        } else if (!data.status) {
          let errors = []
          errors.push(t[language][data.key])
          this.setState({ errors: errors })
        }
      }, error => {
        console.log(error)
        this.setState({ showCommonLoader: false, errorMessage: 'ERROR', successMessage: '' })
      })
    } else {
      this.setState({ errors: result.errors })
    }
  }

  // Cancle All
  cancleAll () {
    let permissionsID = []
    this.setState({ selectedPermissions: permissionsID })
    this.setState({ selectAll: false })
    this.setState({ Rolename: '' })
    this.setState({ Description: '' })
    this.setState({
      PermissionList: this.state.PermissionList.map((item, index) => {
        return item
      })
    })
    window.location.href = '/settings/roles'
  }
  // create New Role
  render () {
    const { language } = this.state
    const addRoleStyle = {
      height: '30px',
      border: '1px solid #b9b9b9',
      width: '220px',
      margin: '0px 0px 5px 0px'
    }
    return (
      <section className='roles'>
        <div className={'successMessage ' + (this.state.isSuccess ? ' show' : 'hide')}>
          <h4>{t[language].recordsaved}</h4>
        </div>
        <div className={'' + (this.state.isSuccess ? 'hide' : 'show')}>
          <h2>{t[language].roledetails}</h2>
          {this.state.showCommonLoader
            ? <CommonLoader className='loader' showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''
          }
          <div className='fleft'>
            <form className={this.state.showCommonLoader ? 'hide' : 'show'}>
              {(this.state.errors !== '') ? <ErrorAlert errorMessage={this.state.errorMessage} errors={this.state.errors} /> : ''}
              <table className='user_form'>
                <tbody>
                  <tr>
                    <th className='req'>
                      <lable translate='' key='rolename'>{t[language].rolename}</lable>
                    </th>
                    <td>
                      <input style={addRoleStyle} type='text' maxLength='100' name='Role_Name'
                        onChange={e => this.handleChange('name', e)}
                        value={this.state.Rolename} />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <lable>
                        <span translate='' key='roledescription'>{t[language].roledescription}:</span>
                        <br />
                        <em>
                          <span>{t[language].optional}</span>
                        </em>
                      </lable>
                    </th>
                    <td>
                      <textarea cols='35' rows='5' name='Role_Description'
                        onChange={e => this.handleChange('desc', e)}
                        value={this.state.Description} />
                    </td>
                  </tr> </tbody>
              </table>
              <h2 className='permissionName'>{t[language].permissions}</h2>
              {this.getPermissionList()}
              <div className='controllers'>
                <a className='controllersWord' onClick={this.selectAllPermissions}
                  translate='' key='selectall'>{t[language].selectall}</a>
                <span>&nbsp;|&nbsp;</span>
                <a className='controllersWord' onClick={this.deselectAllPermissions}
                  translate='' key='deselectall'>{t[language].deselectall}</a>
              </div>
              {checkAccess(CommonConstants.userPermissions.AddRole)
                ? <div className='save'>
                  <span className='additem' type='submit'
                    onClick={e => this.createRole(e)}
                    translate='' key='save'>{t[language].save}</span>
                  <span>&nbsp;|&nbsp;</span>
                  <a className='controllersWord' onClick={this.cancleAll}
                    translate='' key='cancel'>{t[language].cancel}</a>
                </div> : ''}
            </form>
          </div>

        </div>
      </section>
    )
  }
}
function mapStateToProps (state) {
  return {
    roles: state.roles
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getPermissionsList: getPermissionsList
    },
    dispatch
  )
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(AddRoles)



// WEBPACK FOOTER //
// ./src/components/Roles/AddRoles.js